import React from "react";
import { Fragment } from "react";

export default function ReadingHeader() {
  return (
    <Fragment>
      <div className="row customers">
        <div className="col-sm-12">
          <h2>Add Readings</h2>
        </div>
      </div>
    </Fragment>
  );
}
